




































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectMonthComponent from '@/components/SelectMonthComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import { TotalInvoice } from '@/domain/TotalInvoice'
import { WindowPosition } from '@/domain/WindowPosition'
import TotalInvoicesService, { SerchConditon } from '@/service/TotalInvoicesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectMonthComponent,
    CustomerSelectDialogComponent,
    PdfViewComponent,
  },
})
export default class MemberTotalInvoiceList extends Mixins(GlobalMixin) {
  totalInvoicesService = TotalInvoicesService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "合算請求日", value: "totalInvoiceOn", width: "100px" },
          { text: "合算請求番号", value: "totalInvoiceNo", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "合算期間", value: "period", width: "220px" },
          { text: "小計", value: "amount", align: "end", filterable: false, width: "100px" },
          { text: "消費税", value: "tax", align: "end", filterable: false, width: "100px" },
          { text: "請求金額", value: "totalAmount", align: "end", filterable: false, width: "100px" },
          { text: "印刷", value: "printAt", align: "center", filterable: false, width: "80px" },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "120px" },
  ]
  list: TotalInvoice[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.total.invoice.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.total.invoice.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.total.invoice.list.conditions", JSON.stringify(this.conditions))
    this.totalInvoicesService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.mountedDataTable("tool.total.invoice.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: TotalInvoice): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: TotalInvoice) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.totalInvoiceNo) {
      this.$router.push(`/member/total/invoice/edit/${event.totalInvoiceNo}`)
    }
    this.rowItemKey = event.totalInvoiceNo
    this.rowItemClickTime = now
  }

  /**
   * 印刷ボタンのクリック
   */
  onPrint(totalInvoiceNo: string) {
    this.totalInvoicesService.print(totalInvoiceNo)
      .then(dto => {
        this.list.filter(x => x.totalInvoiceNo === totalInvoiceNo)
            .forEach(x => x.printAt = dto.printAt)
        this.openPdfViewDialog("合算請求書印刷", dto.totalInvoiceFile.content)
      })
  }

  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.total.invoice.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.total.invoice.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.total.invoice.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
